import { InputRichText } from '@dixa/lib-shared-habla';
import { useCallback, useContext, useEffect } from 'react';
import { useMount } from 'react-use';

import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

import { MentionsTrigger } from './components/mentionsTrigger/mentionsTrigger';
import { shouldHandleSelectionChange } from './utils/mentions.utils';

export const EditorMentions = (): null => {
  const { conversationNoteMentions } = useFeatureFlag([
    'conversation-note-mentions',
  ]);
  const editorContext = useContext(InputRichText.Context);

  const createTrigger = useCallback(
    () => ({
      id: 'conversation-mentions',
      trigger: /(^|\s)(@$|@\S)/,
      minChars: 0,
      allowSpaces: true,
      component: <MentionsTrigger />,
      persistOnEsc: false,
      shouldHandleSelectionChange: () =>
        shouldHandleSelectionChange(editorContext.selection.recreate()),
    }),
    [editorContext.selection],
  );

  useMount(() => {
    if (!conversationNoteMentions) return;

    editorContext.triggers.add(createTrigger());
  });

  useEffect(() => {
    if (!conversationNoteMentions) return;

    editorContext.triggers.update(createTrigger());
  }, [createTrigger, editorContext.triggers, conversationNoteMentions]);

  return null;
};
